module.exports = __webpack_public_path__ + "img/ic-shopping-cart.0e23f493.svg";